import { McIcon } from "./icon.js"



export class McIconMetric extends McIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" 
  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
  aria-hidden="true">
  <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline>
</svg>
`
    super.addHTML(temp)
  }

}


if (!window.customElements.get("mc-icon-metric")) {
  window.customElements.define("mc-icon-metric", McIconMetric)
}
